import { Grid2 } from "@mui/material";
import React from "react";
import { HelmetDexteel } from "../../../helmet/HelmetDexteel";
import { Logbook } from "./components/Logbook";

// Re-export for backward compatibility
export { useEntries, routeLogbookEntry } from "./hooks/useEntries";

export const LogbookPage = () => {
	return (
		<>
			<HelmetDexteel title="Logbook Entry" />
			<Grid2 container style={{ padding: "1.5rem" }}>
				<Logbook />
			</Grid2>
		</>
	);
};
